import { render, staticRenderFns } from "./section-mark.vue?vue&type=template&id=034a2a67&scoped=true"
import script from "./section-mark.vue?vue&type=script&lang=js"
export * from "./section-mark.vue?vue&type=script&lang=js"
import style0 from "./section-mark.vue?vue&type=style&index=0&id=034a2a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a2a67",
  null
  
)

export default component.exports